import React from "react";
import {
  ColumnContainer,
  RowContainer,
  Column,
} from "../../components/containers/styledComponents";
import { Icon, IconContainer } from "../../components/visuals/styledComponents";
import { LoginCarousel } from "../../components/visuals/LoginCarousel";
import compass_title_logo from "../../assets/svg/compass_title_logo.svg";

export const CarouselColumn = (): JSX.Element => {
  return (
    <ColumnContainer jc="flex-start">
      <RowContainer flex={"0 0 8%"}></RowContainer>
      <RowContainer jc="flex-start" ai="flex-start">
        <Column flex="0 0 20%"></Column>
        <IconContainer size={250}>
          <Icon src={compass_title_logo} alt="Compass logo" />
        </IconContainer>
      </RowContainer>
      <RowContainer>
        <Column flex="0 0 20%"></Column>
        <LoginCarousel />
      </RowContainer>
    </ColumnContainer>
  );
};
